export var groupBy = function (list, getKey) {
    return list.reduce(function (previous, currentItem) {
        var group = getKey(currentItem);
        if (!previous[group])
            previous[group] = [];
        previous[group].push(currentItem);
        return previous;
    }, {});
};
